//# sourceMappingURL=my-calendar-view-changed.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/mydatepicker/dist/interfaces/my-calendar-view-changed.interface.js
// module id = 523
// module chunks = 3